import { displayErrors, clearErrors } from "../../utils/formValidation";
import { getFormData } from "../../helpers/formData";

declare global {
  interface Window {
    preparedForms: string[];
  }
}

function correctKey(key: string) {
  return document.querySelector<HTMLElement>(`[id='${key}']`)?.getAttribute("data-alias") ?? document.querySelector<HTMLElement>(`[data-umb='${key}']`)?.getAttribute("data-alias") ?? key;
}

function init() {
  const recordedDownloadContainers = document.querySelectorAll(
    ".js-recorded-download"
  );

  recordedDownloadContainers.forEach((recordedDownloadContainer) => {
    const formId = recordedDownloadContainer.getAttribute("data-form-id") ?? "";

    if (window.preparedForms && window.preparedForms.includes(formId)) {
      return;
    }

    window.preparedForms = window.preparedForms || [];
    window.preparedForms.push(formId);

    const popover = document.querySelector<HTMLElement>(
      `.js-recorded-download-popover[id="${formId}"]`
    );
    const closeButtons = popover?.querySelectorAll(
      ".js-recorded-download-popover-close"
    );

    popover?.querySelectorAll<HTMLFormElement>("form").forEach((form) => {
      const downloadTrigger
        = recordedDownloadContainer.querySelector<HTMLElement>(
          ".js-download-trigger"
        );
      const submitBtn = form?.querySelector<HTMLButtonElement>(
        "button[type=\"submit\"]"
      );

      // Get pertinent Umbraco Forms input elements
      const downloadInput = form?.querySelector<HTMLInputElement>(
        "[data-alias=\"download\"]"
      );

      if (form && formId) {
        // Populate hidden 'download' form field with value from trigger button
        if (downloadInput) {
          downloadInput.value = downloadTrigger?.getAttribute("data-src") || "";
          downloadInput.dispatchEvent(new Event("change"));
        }

        // Hijack form submission and do it via AJAX instead
        form.addEventListener("submit", async (event) => {
          event.preventDefault();
          if (submitBtn) {
            submitBtn.disabled = true;
          }
          const data = { values: Object.fromEntries(getFormData(form).map(([key, value]) => [correctKey(key), value])) };

          try {
            // Make the AJAX request
            const response = await fetch(
              `/umbraco/forms/api/v1/entries/${formId}`,
              {
                method: "POST",
                headers: {
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              }
            );

            if (!response.ok) {
              const errorData = await response.json();

              // Output errors to UI
              displayErrors(form, errorData.errors);

              if (submitBtn) submitBtn.disabled = false;
              return;
            }
            // Open downloaded resource in new browser window
            if (downloadInput) {
              // Trigger the download
              const downloadURL = downloadInput.value;
              if (submitBtn) submitBtn.disabled = false;
              clearErrors(form);
              window.open(downloadURL, "_blank");

              // Render the success message
              const formContainer = form.closest(".umbraco-forms-form");
              const body = await response.json();
              const successMessage = document.createElement("div");
              successMessage.classList.add("umbraco-forms-submitmessage");
              successMessage.innerHTML = body.messageOnSubmit;
              formContainer?.append(successMessage);
              form.remove();
            }
          }
          catch (error) {
            console.error("Unexpected error:", error);
          }
        });
      }
    });

    closeButtons?.forEach((closeButton) => {
      closeButton.addEventListener("click", () => {
        window.location.reload();
      });
    });
  });
}

export default () => {
  init();
};
